export { SAPOMailConfigSingleton as default };

/**
* Stores webmail config data set by the server
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class SAPOMailConfig {

  /**
   * Stores all data set by the server initinal request
   *
   * @since 7.0.0
   *
   * @param {Object} server webmail server configuration data
   */
  server = {};

  /**
   * Client data configuration
   *
   * @since 7.0.0
   *
   * @param {Object} client webmail client configuration data
   */
  client = {
    version: {
      js: '7.2.2r003'
    },

    session : {
      bind_interval: 60 * 2000,
      checkin_url : '/checkin/login.php',
    },

    preloader : {
      enabled      : true,
      closing_delay: 50,
    },

    endpoints: {
      imp_services : 'services.php/imp',
      imp_search   : 'imp/basic.php',
      imp_view     : 'imp/view.php',
      imp_download : 'imp/download.php',

      contacts : {
        turba    : 'services.php/turba',
        api      : 'services.php/imp',
        export   : 'services/download',
      },

      feedback : {
        services : 'services.php/imp',
      },

      settings : {
        generic     : 'services/settings/generic.php',
        imp         : 'services.php/imp',
        filters     : 'services.php/ingo',
        basic       : 'ingo/basic.php',
        housekeeper : 'services/housekeeper',
      },

      messages : {
        services : 'services.php/imp',
        view     : 'imp/view.php',
        search   : 'imp/basic.php',
        download : 'imp/download.php',
      },

      logging: {
        javascript: 'services.php/imp'
      },

      context : {
        selection_limit : {
          spam      : 30,
          whitelist : 30,
          blacklist : 30,
        }
      }
    },

    requests: {
      messages : {
        delay : 30,
      }
    },

    folders : {
      main : {
        SU5CT1g      : 'inbox',
        RW52aWFkb3M  : 'sent',
        TGl4bw       : 'trash',
        UmFzY3VuaG9z : 'drafts',
        U3BhbQ       : 'spam',
      },

      alias :  {
        inbox        : 'SU5CT1g',
        sent         : 'RW52aWFkb3M',
        trash        : 'TGl4bw',
        drafts       : 'UmFzY3VuaG9z',
        spam         : 'U3BhbQ',
        search_all   : 'YWxsAA',
        search       : 'aW1wc2VhcmNoAGltcHFzZWFyY2g'
      },

      imap_name : {
        'SU5CT1g'     : 'INBOX',
        'RW52aWFkb3M' : 'Sent',
      },

      icons : {
        'SU5CT1g'      : 'fas fa-inbox',
        'RW52aWFkb3M'  : 'fas fa-paper-plane',
        'UmFzY3VuaG9z' : 'fas fa-edit',
        'TGl4bw'       : 'fas fa-trash-alt',
        'U3BhbQ'       : 'fas fa-shield-alt',
        'YWxsAA'       : 'fas fa-folder',
        '_TOPFOLDER_'  : 'fas fa-folder',
        '_ALLFOLDERS_' : 'fas fa-folder',
        'default'      : 'far fa-folder',
      },

      disable_empty : {
        'SU5CT1g'     : true,
        'RW52aWFkb3M' : true,
      },

      quick_empty : {
        'TGl4bw' : true,
        'U3BhbQ' : true,
      },

      delete_warning : {
        enabled :  {
          'TGl4bw' : true,
          'U3BhbQ' : true,
        },

        count : 30,
      }
    },

    viewport : {
      slice_size : 30,
      report_spam_limit: 40,
    },

    compose : {
      attachments : {
        file_limit : 40,
        size_limit : 20000000,
      },

      sapo_transfer : {
        size_limit : 3000000000,
      },

      meo_cloud : {
        size_limit : 3000000000,
      },

      recipients_limit       : 150,
      auto_save_draft        : {
        enabled  : true,
        interval : 45 * 1000,
      }
    },

    notifications : {
      timeout: 5,

      browser: {
        document_visibility: 'hidden',
        incoming_message: {
          disabled_folders: {
            'U3BhbQ'       : true,
            'UmFzY3VuaG9z' : true,
          }
        }
      }
    },

    emojis : {
      path      : 'https://mail.web.sapo.io/static/emojis/',
      extension : '.png',
      width     : 32,
      height    : 32,
    },

    help : {
      url : 'https://contacto.ajuda.sapo.pt/',
    },
    
    ads: {
        fallback: {
            links: {
                subscricoes: 'https://subscricoes.sapo.pt/'
            }
        }
    },

    settings : {
      signature : {
        'html_size_limit' : 35000,
        'image_size_limit': 25000,
      }
    },

  }
}

const SAPOMailConfigSingleton = new SAPOMailConfig();
